import { MasterButton } from "App/Component/ui";
import React from "react";
import { useSelector } from "react-redux";
import {
  handleClickCetakLabel,
  handleClickCetakLabelX,
  handleClickCetakManualLabel,
} from "../../utils";

function ButtonActionIgd({ formData, registrationId }) {
  const { setting } = useSelector((state) => state);
  const cetakButtonIGD = setting.cetak_button_igd;
  return (
    <>
      {parseInt(cetakButtonIGD.label_x) === 1 && (
        <MasterButton
          type='button'
          color='green'
          name='CETAK LABEL X'
          outline={true}
          size='md'
          onClick={() =>
            handleClickCetakLabelX(formData, registrationId, "print-1x-label-x")
          }
        />
      )}

      {parseInt(cetakButtonIGD.label_manual) === 1 && (
        <MasterButton
          type='button'
          color='green'
          name='CETAK LABEL MANUAL'
          outline={true}
          size='md'
          onClick={() =>
            handleClickCetakManualLabel(
              formData,
              registrationId,
              "print-2x-label"
            )
          }
        />
      )}

      {parseInt(cetakButtonIGD.label_2x) === 1 && (
        <MasterButton
          type='button'
          outline={true}
          color={"green"}
          name={"CETAK 2x LABEL"}
          size='md'
          onClick={() =>
            handleClickCetakLabel(formData, registrationId, "print-2x-label")
          }
        />
      )}

      {parseInt(cetakButtonIGD.label_4x) === 1 && (
        <MasterButton
          type='button'
          outline={true}
          color={"green"}
          name={"CETAK 4x LABEL"}
          size='md'
          onClick={() =>
            handleClickCetakLabel(formData, registrationId, "print-4x-label")
          }
        />
      )}

      {parseInt(cetakButtonIGD.label_6x) === 1 && (
        <MasterButton
          type='button'
          outline={true}
          color={"green"}
          name={"CETAK 6x LABEL"}
          size='md'
          onClick={() =>
            handleClickCetakLabel(formData, registrationId, "print-6x-label")
          }
        />
      )}
    </>
  );
}

export default ButtonActionIgd;
